import React from 'react';
import { Helmet } from 'react-helmet';

function FreshdeskChat() {
  const freshdeskEnabled = process.env.REACT_APP_FRESHDESK_ENABLED === 'true';

  if (!freshdeskEnabled) return null;

  return (
    <Helmet
      script={[
        {
          type: 'text/javascript',
          innerHTML: `
          function initFreshChat() {
            window.fcWidget.init({
              token: "9fb56091-464a-4c46-851a-9211b67db622",
              host: "https://wchat.freshchat.com"
            })
          }
          function initialize(i, t) { var e; i.getElementById(t) ? initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.freshchat.com/js/widget.js", e.onload = initFreshChat, i.head.appendChild(e)) } function initiateCall() { initialize(document, "Freshdesk Messaging-js-sdk") } window.addEventListener ? window.addEventListener("load", initiateCall, !1) : window.attachEvent("load", initiateCall, !1);
        `
        }
      ]}
    ></Helmet>
  );
}

export default FreshdeskChat;
